<!DOCTYPE html>
<html>
  <body *ngIf="isReady">
    <h1 *ngIf="userAuthCodeOrToken !== null">{{'HOME.ARCGIS.SUCCESS_LOGIN_DIALOG' | translate}}</h1>
    <h1 *ngIf="userAuthCodeOrToken === null">{{'HOME.ARCGIS.CANCELLED_LOGIN_DIALOG' | translate}}</h1>
  </body>
</html>